import React from 'react';
import { ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';
import styled from '../styled';
import { Tooltip } from 'antd';
import { floor, multiply } from 'lodash';
const { mr } = styled;

export const cellViewClusterMeanField = ({ threshold, clusterMean = 0 }) => {
  return (
    <div style={{ display: 'flex' }}>
      <Tooltip title={clusterMean}>
        <span style={mr}> {floor(clusterMean, 2)} </span>
      </Tooltip>
      {threshold < clusterMean && <ArrowUpOutlined style={{ color: 'red' }} />}
      {threshold > clusterMean && (
        <ArrowDownOutlined style={{ color: 'navy' }} />
      )}
    </div>
  );
};

export const cellViewValueField = (
  { threshold, value = null, clusterMean = null },
  enableClusterMean
) => {
  return (
    <div style={{ display: 'flex' }}>
      <Tooltip title={value}>
        <span style={mr}> {floor(value, 2)} </span>
      </Tooltip>
      {enableClusterMean ? (
        <>
          {clusterMean < value && <ArrowUpOutlined style={{ color: 'red' }} />}
          {clusterMean > value && (
            <ArrowDownOutlined style={{ color: 'navy' }} />
          )}
        </>
      ) : (
        <>
          {threshold < value && <ArrowUpOutlined style={{ color: 'red' }} />}
          {threshold > value && <ArrowDownOutlined style={{ color: 'navy' }} />}
        </>
      )}
    </div>
  );
};

export const cellViewImportantField = ({ riskLevel, importance = 0 }) => {
  const pickColor = { high: 'red', medium: 'orange', low: 'green' };
  const status = riskLevel ? riskLevel?.toLowerCase() : '';
  const percentage = multiply(importance, 100);
  const value = floor(percentage, 2);
  const perStr = percentage > 0 ? '%' : '';
  return (
    <div style={{ fontWeight: 'bolder' }}>
      <Tooltip title={`${percentage} ${perStr}`}>
        <span style={{ color: pickColor[status] }}>{`${value} ${perStr}`}</span>
      </Tooltip>
    </div>
  );
};
